import React, { useState, useEffect } from "react";
import FirmaContent from "./AccordionSections/FirmaContent";
import RevisionContent from "./AccordionSections/RevisionContent";
import DocsContent from "./AccordionSections/DocsContent";
import {
  Box,
  Accordion,
  AccordionActions,
  AccordionSummary,
  AccordionDetails,
  Grid,
} from "@mui/material/";

// ICONS OPEN
import {
  AccessTime,
  Check,
  ExpandMore,
  Info,
  WarningAmber,
  History,
  QuestionMark,
  Close,
  Send,
  Mail,
} from "@mui/icons-material";
import { quitarTildes, statusConfig } from "../../Components/helpers/Helpers";
import { CustomIconsPlusText } from "../../Components/Common/Design/CustomIconsPlusText";
import StepsForm from "./AccordionSections/StepsForm";
import api from "../../api/axios";
import FormFI from "../Components/FormFI";
// ICONS CLOSED

const FlowSectionAccordion = ({
  dataCase,
  caseContract,
  acceptedContract,
  caseId,
  userLogged,
  mailTemplates,
  updatedCase,
  setUpdatedCase,
}) => {
  const Swal = require("sweetalert2");
  const [expanded, setExpanded] = useState(false);
  const [changed, setChanged] = useState(false);

  // 👉 construimos taskFlow cada vez que cambie dataCase
  const taskFlow = React.useMemo(() => {
    const obj = {};
    dataCase?.tasks?.forEach((task) => {
      obj[task.task_id] = {
        status: task.status,
        date_in: task.date_in,
        date_end: task.date_end,
        date_update: task.date_update !== "" ? task.date_update : "",
        config: task.config,
        message: task.message,
        id: task.id,
        task_id: task.task_id,
      };
    });
    return obj;
  }, [dataCase?.tasks]);

  const nextTask = async (
    config,
    task_status,
    status_desicion,
    message,
    anotherTask,
  ) => {
    console.log(task_status, status_desicion);
    let ultimo;
    try {
      if (status_desicion === "lastone") {
        ultimo = dataCase.completeFlow[dataCase.completeFlow.length - 1];
      }

      console.log(ultimo);

      Swal.fire({
        title: "Cargando...",
        html: '<div class="swal-loader"></div>',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      let nextId;
      let nextTime;

      for (let i = 0; i < dataCase?.completeFlow.length; i++) {
        const element = dataCase?.completeFlow;
        if (dataCase?.task?.task_id === element[i].id) {
          nextId = element[i + 1]?.id;
          nextTime = element[i + 1]?.status_user_max_delay;
        }
      }

      const exists = dataCase?.completeFlow?.some((flow) => flow.id === nextId);

      if (!exists) {
        Swal.close();
        Swal.fire({
          title: "Flujo completado",
          text: "No existen más tareas en este caso.",
          icon: "info",
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Aceptar",
        });
        return;
      }

      //  Datos para actualizar la tarea
      const payload = {
        case_status: ultimo?.id
          ? ultimo.id
          : !status_desicion || status_desicion === "next"
            ? nextId
            : dataCase?.task?.task_id,
        case_id: Number(caseId),
        task_id: ultimo?.id ? ultimo.id : nextId,
        status: task_status,
        config: JSON.stringify(config),
        next_config: JSON.stringify({}),
        current_task: dataCase?.task?.task_id,
        update_desicion: status_desicion,
        status_user_max_delay: ultimo?.id ? ultimo.id : nextTime,
        client_name: dataCase?.full_client_name,
      };

      // Si hay mensaje, lo agregamos
      if (message !== "") {
        payload.message = JSON.stringify(message);
      } else {
        payload.message = "";
      }

      console.log(payload);

      // Ahora generamos el FormData
      const formDataTask = new FormData();
      Object.entries(payload).forEach(([key, value]) => {
        formDataTask.append(key, value);
      });

      const urlTask = `${process.env.REACT_APP_API_URL}/casestasks/nexttask`;
      const responseTask = await api.post(urlTask, formDataTask);

      console.log(responseTask, "tasks actualizadas");
      setUpdatedCase(!updatedCase);

      Swal.close();
      Swal.fire({
        title: "Guardado",
        text: "El caso ha sido actualizado correctamente",
        icon: "success",
        timer: 2000,
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Continuar",
      }).then((result) => {
        if (result.isConfirmed) {
          setChanged(!changed);
        }
      });
    } catch (err) {
      Swal.close();

      //   Detectamos tipo de error para dar mejor feedback
      let errorMessage = "Ocurrió un error inesperado. Intenta nuevamente.";

      if (err.response) {
        // Error del servidor con respuesta
        errorMessage = err.response.data?.message || "Error en el servidor.";
      } else if (err.request) {
        // El servidor no respondió
        errorMessage = "No hay conexión con el servidor. Revisa tu red.";
      } else {
        // Error en la configuración de la petición
        errorMessage = `Error: ${err.message}`;
      }

      console.error("   Error en nextTask:", err);

      Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonColor: "#d33",
        confirmButtonText: "Cerrar",
      });
    }
  };

  useEffect(() => {
    if (dataCase?.task?.task_id) {
      setExpanded(dataCase.task.task_id);
    }
  }, [dataCase]);

  return (
    <Box
      sx={{
        width: "100%",
        padding: "10px",
      }}>
      {dataCase?.completeFlow?.map((section, index) => {
        const taskData = taskFlow[section.id]; // aquí tienes la info de cada task
        const date = new Date(taskData?.date_update);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        const formattedDate = `${year}-${month}-${day}`;

        return (
          <Accordion
            key={index}
            sx={{ width: "100%" }}
            expanded={expanded === section.id}
            onChange={() =>
              setExpanded(expanded === section.id ? false : section.id)
            }>
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls={`panel${index + 1}-content`}
              id={`panel${index + 1}-header`}>
              <Grid container>
                <b className="infoStyle">
                  {index + 1 + ". " + section.status_name + " "}
                </b>

                {/* Última actualización */}
                {taskData?.date_update ? (
                  <CustomIconsPlusText
                    icon={History}
                    styles={{ width: "15px", height: "15px" }}
                    text={`Última actualización: ${formattedDate}`}
                  />
                ) : (
                  <CustomIconsPlusText
                    icon={Close}
                    styles={{ width: "15px", height: "15px" }}
                    text={`Nunca`}
                  />
                )}

                {/* Estado */}
                {taskData?.status
                  ? (() => {
                      const state = taskData?.status;
                      const config = statusConfig[state]; // obtiene el config según el índice

                      return (
                        <CustomIconsPlusText
                          icon={config?.icon || Close}
                          severity={config?.severity}
                          variant={config?.variant}
                          styles={{ width: "15px", height: "15px" }}
                          text={
                            config
                              ? config.text(section?.status_name)
                              : "No iniciado"
                          }
                        />
                      );
                    })()
                  : null}

                {/* Fecha límite */}
                {taskData?.status === 0 &&
                  taskData?.date_end &&
                  (() => {
                    const now = new Date();
                    const end = new Date(taskData.date_end);
                    const diffDays = Math.ceil(
                      (end - now) / (1000 * 60 * 60 * 24),
                    );

                    if (diffDays > 5) {
                      return (
                        <CustomIconsPlusText
                          icon={AccessTime}
                          severity="info"
                          styles={{ width: "15px", height: "15px" }}
                          text={`${diffDays} días para finalizar la tarea`}
                        />
                      );
                    } else if (diffDays > 0) {
                      return (
                        <CustomIconsPlusText
                          blink="blinking"
                          variant="filled"
                          icon={WarningAmber}
                          severity="warning"
                          styles={{ width: "15px", height: "15px" }}
                          text={`${diffDays} días para finalizar la tarea`}
                        />
                      );
                    } else {
                      return (
                        <CustomIconsPlusText
                          blink="blinking"
                          icon={WarningAmber}
                          severity="error"
                          variant="filled"
                          styles={{ width: "15px", height: "15px" }}
                          text={`Tarea vencida hace ${Math.abs(diffDays)} días`}
                        />
                      );
                    }
                  })()}

                {/* Solicitud y notificación */}
                {taskData?.status === 0 &&
                  !/Firma|Documentacion|Revision|Finalizado/.test(
                    section.status_name,
                  ) &&
                  (() => {
                    let config = null;
                    try {
                      config = taskData?.config
                        ? JSON.parse(taskData.config)
                        : null;
                    } catch {
                      config = null;
                    }

                    if (config?.solicitud || config?.notificacion) {
                      return (
                        <>
                          <CustomIconsPlusText
                            icon={Send}
                            severity="success"
                            styles={{ width: "15px", height: "15px" }}
                            text={`Solicitud ${section.status_name} realizada ${config.solicitud.date}`}
                          />

                          {config?.notificacion ? (
                            <CustomIconsPlusText
                              icon={Mail}
                              severity="success"
                              styles={{ width: "15px", height: "15px" }}
                              text={`Notificación ${section.status_name} recibida ${config.notificacion.date}`}
                            />
                          ) : (
                            <CustomIconsPlusText
                              icon={AccessTime}
                              severity="warning"
                              styles={{ width: "15px", height: "15px" }}
                              text={`Pendiente recibir notificación ${section.status_name}`}
                            />
                          )}
                        </>
                      );
                    } else {
                      return (
                        <CustomIconsPlusText
                          icon={AccessTime}
                          severity="warning"
                          styles={{ width: "15px", height: "15px" }}
                          text={`Pendiente Solicitud ${section.status_name}`}
                        />
                      );
                    }
                  })()}
              </Grid>
            </AccordionSummary>

            <AccordionDetails>
              {(() => {
                switch (quitarTildes(section.status_name)) {
                  case "firma":
                    return section.order <= dataCase?.flow?.order &&
                      dataCase?.task?.status != 2 ? (
                      <Box>
                        <Box
                          sx={{
                            margin: "auto",
                            mt: 4,
                            mb: 4,
                            // width: "100%",
                            maxWidth: "900px",
                            p: 4,
                            borderRadius: "4px",
                            background: "rgba(255,255,255,0.92)",
                            boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                          }}>
                          <FirmaContent
                            rerender={changed ? "firma-1" : "firma-0"}
                            caseContract={caseContract}
                            flagAcceptReject={
                              section.id === dataCase?.task?.task_id || false
                            }
                            acceptedContract={acceptedContract}
                            nextTask={nextTask}
                            activeTask={taskData}
                            setUpdatedCase={setUpdatedCase}
                            updatedCase={updatedCase}
                            dataCase={dataCase}
                            usersFlag={true}
                          />
                        </Box>
                      </Box>
                    ) : null;
                  case "documentacion":
                    return (
                      <DocsContent
                        sectionId={section.id}
                        caseId={caseId}
                        nextTask={nextTask}
                        userLogged={userLogged}
                        dataCase={dataCase}
                        setUpdatedCase={setUpdatedCase}
                        updatedCase={updatedCase}
                        activeTask={taskData}
                      />
                    );
                  // section.order <= dataCase?.flow?.order &&
                  //   dataCase?.task?.status != 2 ? (

                  // ) : null;
                  case "formulario fi":
                    if (
                      section.order <= dataCase?.flow?.order &&
                      dataCase?.task?.status !== 2
                    ) {
                      return (
                        <FormFI
                          sectionId={section.id}
                          caseId={caseId}
                          nextTask={nextTask}
                          userLogged={userLogged}
                          dataCase={dataCase}
                          setUpdatedCase={setUpdatedCase}
                          updatedCase={updatedCase}
                          activeTask={taskData}
                        />
                      );
                    } else {
                      return null;
                    }
                  case "revision":
                    return section.order <= dataCase?.flow?.order &&
                      dataCase?.task?.status != 2 ? (
                      <RevisionContent
                        mailTemplatesData={mailTemplates}
                        nextTask={nextTask}
                        dataCase={dataCase}
                        userLogged={userLogged}
                        caseId={caseId}
                        setUpdatedCase={setUpdatedCase}
                        updatedCase={updatedCase}
                        activeTask={taskData}
                      />
                    ) : null;
                  default:
                    return (
                      section.order <= dataCase?.flow?.order && (
                        <StepsForm
                          mailTemplatesData={mailTemplates}
                          nextTask={nextTask}
                          dataCase={dataCase}
                          caseId={caseId}
                          setUpdatedCase={setUpdatedCase}
                          updatedCase={updatedCase}
                          activeFlow={section}
                          activeTask={taskData}
                          userLogged={userLogged}
                        />
                      )
                    );
                }
              })()}
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Box>
  );
};

export default FlowSectionAccordion;
